import {
  sceneDataExist,
  getSceneModelsPath,
  getSceneMaterials,
  getSceneCamera,
  getSceneDuration
} from '../helpers/DataHelper'
import { createCamera, createScene3D, createObject3D } from '../helpers/3DEngineHelper'
import Scene from './Scene'
import MotionCam from './MotionCam'
import { registerMaterial } from '../helpers/MaterialHelper'

const INTRO_DURATION = 5500
const OUTRO_DURATION = 5500
class SceneManager {
  
  constructor() {
    this.scene3D = createScene3D()
    this.camera = createCamera()
    this.container = createObject3D()
    this.scene3D.add(this.container)
    this.motionCam = new MotionCam(this.camera)
    this.scenes = []
    this.current = -1
  }

  get currentScene () {
    return this.scenes[this.current]
  }

  loadSceneId (id, onProgress) {
    return new Promise((resolve, reject) => {
      if (!sceneDataExist(id)) {
        reject(new Error('No scene data found for id' + id))
        return
      }
      if (this.scenes[id]) {
        resolve(this.scenes[id])
        return;
      }
      const scene = new Scene();
      scene.load(getSceneModelsPath(id), getSceneMaterials(id), onProgress)
      .then(() => {
        this.scenes[id] = scene
        resolve(this.scenes[id])
      })
      .catch(error => {
        reject('Error on import scene', error)
      })
    })
  }

  displayScene (id, onLoadProgress, onAdd, onIntroStart, delayIntro = 0) {
    return new Promise((resolve, reject) => {
      const onSceneLoaded = scene => {
        scene.materials.map(mat => registerMaterial(mat))
        this.current = id
        this.addScene(this.current, onAdd || (() => {}))
        this.motionCam.setAnimation(getSceneCamera(id), getSceneDuration(id))
        if (onIntroStart) onIntroStart(scene)
        this.motionCam.intro(INTRO_DURATION, delayIntro)
        this.currentScene.intro().then(() => { resolve(id) })
      }
      if (this.current >= 0 && this.current < this.scenes.length) {
        this.removeScene(this.current)
        this.current = id
        this.loadSceneId(id, onLoadProgress)
        .then(onSceneLoaded)
        .catch(error => {console.error(error)})
      } else {
        this.loadSceneId(id, onLoadProgress)
        .then(onSceneLoaded)
        .catch(error => {console.error(error)})
      }
    })
  }

  reverseIntro () { this.motionCam.introReverse() }

  hideCurrentScene () {
    return new Promise( resolve => {
      this.motionCam.outro(OUTRO_DURATION).then(() => resolve())
    })
  }

  play (completeHandler) {
    this.container.scale.set(1, 1, 1)
    this.container.rotation.set(0, 0, 0)
    this.motionCam.playTween(completeHandler)
  }

  display() {
    this.currentScene.container.visible = true
  }

  hide() {
    this.currentScene.container.visible = false
  }
  
  addScene (id, onAdd) {
    this.current = id
    this.currentScene.addTo(this.container, onAdd)
  }

  removeScene (id) {
    this.currentScene.removeFrom(this.container)
    this.current = null
  }

  setSize (width, height) {
    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()
  }
}
export default SceneManager


// WEBPACK FOOTER //
// ./src/scripts/webgl/SceneManager.js